import request from './request'

export function getCategoryList() {
  return request({ url: '/api/pub/category/list', method: 'get' })
}

export function getToolList(params) {
  return request({ url: '/api/pub/tool/list', method: 'get', params })
}

export function getToolDetail(slug) {
  return request({ url: `/api/pub/tool/detail/${slug}`, method: 'get' })
}

export function getHotTools(limit) {
  return request({ url: '/api/pub/tool/hot', method: 'get', params: { limit } })
}

export function getRecentTools(limit) {
  return request({ url: '/api/pub/tool/recent', method: 'get', params: { limit } })
}

export function getToolsByCategory(categoryId) {
  return request({ url: '/api/pub/tool/by-category', method: 'get', params: { categoryId } })
}

export function searchTools(params) {
  return request({ url: '/api/pub/tool/search', method: 'get', params })
}

export function recordUsage(toolId) {
  return request({ url: '/api/pub/tool/record-usage', method: 'post', params: { toolId } })
}

export function toggleFav(toolId, isFav) {
  return request({ url: '/api/pub/tool/toggle-fav', method: 'post', params: { toolId, isFav } })
}

// ---- 条形码解码 ----
export function decodeBarcode(formData) {
  return request({ url: '/api/pub/barcode/decode', method: 'post', data: formData })
}

// ---- 文件转换 (FormData 不显式设 Content-Type，让浏览器自动带 boundary) ----
export function convertWordToHtml(formData) {
  return request({ url: '/api/pub/convert/word-to-html', method: 'post', data: formData, responseType: 'json', timeout: 300000 })
}

export function convertWordToPdf(formData) {
  return request({ url: '/api/pub/convert/word-to-pdf', method: 'post', data: formData, timeout: 300000 })
}

export function convertPdfToWord(formData) {
  return request({ url: '/api/pub/convert/pdf-to-word', method: 'post', data: formData, timeout: 300000 })
}

export function convertPptToWord(formData) {
  return request({ url: '/api/pub/convert/ppt-to-word', method: 'post', data: formData, timeout: 300000 })
}

export function convertExcelToWord(formData) {
  return request({ url: '/api/pub/convert/excel-to-word', method: 'post', data: formData, timeout: 300000 })
}

// ---- 广告 ----
export function getActiveAd(pageType) {
  return request({ url: '/api/pub/ad/active', method: 'get', params: { pageType } })
}

export function getActiveAds(pageType) {
  return request({ url: '/api/pub/ad/active/list', method: 'get', params: { pageType } })
}

export function recordAdClick(data) {
  return request({ url: '/api/pub/ad/click', method: 'post', data })
}

// ---- IP归属地 ----
export function queryIp(ip) {
  return request({ url: '/api/pub/ip/query', method: 'get', params: { ip } })
}

// ---- 合作伙伴 ----
export function getPartners() {
  return request({ url: '/api/pub/partner/list', method: 'get' })
}
